/*
  Caviére pairings on the product page (Feature 7)
  When the shopper taps Add to cart (or the sticky bar), anything ticked in
  "Complete the ritual" is added first, then the tin is added as normal and
  the cart drawer opens showing everything. Nothing is ever pre-ticked.
  Plain JavaScript, no libraries. About 2 KB.
*/
(function () {
  if (window.__cavierePairings) return;
  window.__cavierePairings = true;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function boxFor(form) {
    var scope = form.closest('product-info') || form.closest('.product') || document;
    return scope.querySelector('[data-cav-pairings]');
  }

  function updateTotal(box) {
    var total = 0;
    box.querySelectorAll('.cav-pair__input:checked').forEach(function (input) {
      total += Number(input.getAttribute('data-price')) || 0;
    });
    var line = box.querySelector('.cav-pairs__total');
    if (!line) return;
    var template = box.getAttribute('data-adds-text') || 'Adds [amount] to your order';
    line.textContent = total > 0 ? template.replace('[amount]', money(total)) : '';
  }

  document.addEventListener('change', function (event) {
    if (!event.target.classList || !event.target.classList.contains('cav-pair__input')) return;
    var box = event.target.closest('[data-cav-pairings]');
    if (box) updateTotal(box);
  });

  // Runs before Dawn's own Add to cart handler (capture phase).
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (form.getAttribute('data-cav-pairings-done') === 'true') {
        form.removeAttribute('data-cav-pairings-done');
        return;
      }
      var box = boxFor(form);
      if (!box) return;
      var ticked = Array.prototype.slice.call(box.querySelectorAll('.cav-pair__input:checked'));
      if (!ticked.length) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var button = form.querySelector('[type="submit"]');
      if (button) button.setAttribute('aria-busy', 'true');

      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: ticked.map(function (input) {
            return { id: Number(input.getAttribute('data-variant-id')), quantity: 1 };
          })
        })
      })
        .catch(function () {
          // If a pairing cannot be added, the tin is still added below.
        })
        .then(function () {
          ticked.forEach(function (input) {
            input.checked = false;
          });
          updateTotal(box);
          if (button) button.removeAttribute('aria-busy');
          form.setAttribute('data-cav-pairings-done', 'true');
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(button || undefined);
          } else if (button) {
            button.click();
          }
        });
    },
    true
  );
})();